import React from 'react';
import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import { FormFooter as AkFormFooter } from '@atlaskit/form';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

type Props = {
	isDisabled?: boolean;
	isLoading?: boolean;
	isSecondary?: boolean;
} & Intl & {
		type?: string;
		onCancel: () => void;
		onSave: () => void;
	};

const FooterView = ({
	intl: { formatMessage },
	type,
	onCancel,
	onSave,
	isLoading,
	isDisabled,
	isSecondary,
}: Props) => (
	<AkFormFooter>
		<ButtonGroup>
			<Button
				testId="servicedesk-sla-settings.common.ui.footer.cancel-button"
				appearance={isSecondary ? 'subtle-link' : 'default'}
				onClick={onCancel}
			>
				{formatMessage(messages.cancel)}
			</Button>
			<LoadingButton
				// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '"button" | "reset" | "submit" | undefined'.
				type={type}
				appearance={isSecondary ? 'subtle' : 'primary'}
				onClick={onSave}
				isLoading={isLoading}
				isDisabled={isDisabled}
				testId="servicedesk-sla-settings.common.ui.footer.submit-button"
			>
				{formatMessage(messages.save)}
			</LoadingButton>
		</ButtonGroup>
	</AkFormFooter>
);

export const Footer = injectIntl(FooterView);
